module.exports = __webpack_public_path__ + "f07e4b25935b9ffb74e316dd04a3a806.png";